/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getVacuumPhoto } from "@/api/homeassistant";

/**
 * The vacuum's picture: the photo uploaded for it, or (until there is one) a
 * simple round robot drawing. The photo is cached for the session.
 */
export const VacuumArt: React.FC<{ photo?: boolean; cleaning?: boolean; className?: string }> = ({ photo = false, cleaning = false, className }) => {
  const { data: src } = useQuery({ queryKey: ["vacuum-photo"], queryFn: getVacuumPhoto, enabled: photo, staleTime: Infinity, gcTime: Infinity, retry: false });
  if (photo && src) {
    return <img src={src} alt="" className={`hub-vacimg${cleaning ? " hub-vacimg--on" : ""}${className ? ` ${className}` : ""}`} draggable={false} />;
  }
  return (
    <svg viewBox="0 0 100 100" className={`hub-vacart${cleaning ? " hub-vacart--on" : ""}${className ? ` ${className}` : ""}`} aria-hidden="true">
      <circle cx="50" cy="50" r="44" fill="#f4f1ea" stroke="rgba(0,0,0,0.25)" strokeWidth="2" />
      <circle cx="50" cy="46" r="9" fill="#2a2a2a" />
      <circle cx="50" cy="46" r="5" fill="none" stroke="#58b883" strokeWidth="2" />
      <path d="M18 62a36 36 0 0 0 64 0" fill="none" stroke="rgba(0,0,0,0.2)" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
